import { FunctionComponent, ReactNode } from 'react';
import { twMerge } from 'src/utils/twMerge';

type Props = {
  children: ReactNode;
  isRow?: boolean;
  className?: string;
  role?: 'radiogroup' | 'group';
  'data-testid'?: string;
};

const ButtonStack: FunctionComponent<Props> = ({
  children,
  isRow = false,
  className,
  role,
  'data-testid': dataTestId,
}) => (
  <div
    role={role}
    data-testid={dataTestId}
    className={twMerge(
      'flex w-full',
      isRow ? 'flex-row items-center' : 'flex-col',
      className,
      'gap-3',
    )}
  >
    {children}
  </div>
);

export default ButtonStack;
